import Keycloak from 'keycloak-js';

const keycloakConfig = {
    url: "https://keycloak.new-labs.co/auth",
    realm: window.KEYCLOAK_REALM,
    clientId: "featurely-ui"
}
const keycloak = new Keycloak(keycloakConfig);
export default keycloak;